import { render, staticRenderFns } from "./WhyStep.vue?vue&type=template&id=09aa14ce&scoped=true&"
import script from "./WhyStep.vue?vue&type=script&lang=js&"
export * from "./WhyStep.vue?vue&type=script&lang=js&"
import style0 from "./WhyStep.vue?vue&type=style&index=0&id=09aa14ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09aa14ce",
  null
  
)

export default component.exports